// import authorImg from '../../assets/img/testimonial/testi-1.png';
// import shaperImg from '../../assets/img/testimonial/testi-item-shape-1.png';

// const SingleTestimonialFive = (props) => {
//   const { itemClass, Shape, Image, Title, Designation, Description } = props;

//   return (
//     <div
//       className={
//         itemClass
//           ? itemClass
//           : 'testimonial__item d-flex justify-content-betweena align-items-center p-relative'
//       }
//     >
//       <div className="testimonial__item d-flex justify-content-betweena align-items-center p-relative">
//         <div className="testimonial__item-shape">
//           <img src={Shape ? Shape : shaperImg} alt="" />
//         </div>
//         <div className="testimonial__content">
//           <div className="testimonial__author-info">
//             <h5 className="testimonial__author-name">
//               {Title ? Title : 'Karon Rubel'}
//             </h5>
//             <span>{Designation ? Designation : 'Founder'}</span>
//           </div>
//           <div className="testimonial__content-text">
//             <p>
//               {Description
//                 ? Description
//                 : 'We are privileged to work with hundreds future businesses, including many of the world’s software, and brands'}
//             </p>
//             <i className="fas fa-star"></i>
//             <i className="fas fa-star"></i>
//             <i className="fas fa-star"></i>
//             <i className="fas fa-star"></i>
//             <i className="fas fa-star star-color"></i>
//           </div>
//         </div>
//         <div className="testimonial__main-img">
//           <img src={Image ? Image : authorImg} alt={Title} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SingleTestimonialFive;
import React from 'react';
import shaperImg from '../../assets/img/testimonial/testi-item-shape-1.png';

const SingleTestimonialFive = (props) => {
  const { itemClass, Shape, Title, Designation, Description } = props;

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'testimonial__item d-flex justify-content-betweena align-items-center p-relative'
      }
    >
      <div className="testimonial__item d-flex justify-content-betweena align-items-center p-relative">
        <div className="testimonial__item-shape">
          <img src={Shape ? Shape : shaperImg} alt="" />
        </div>
        <div className="testimonial__content">
          <div className="testimonial__author-info">
            <h5 className="testimonial__author-name">
              {Title ? Title : 'Karon Rubel'}
            </h5>
            <span>{Designation ? Designation : 'Founder'}</span>
          </div>
          <div className="testimonial__content-text">
            <p>
              {Description
                ? Description
                : 'We are privileged to collaborate with a diverse range of businesses across India. Our innovative solutions have not only streamlined operations but have also set new benchmarks in digital transformation. At PRD Infotech, we continuously strive to exceed our clients’ expectations by delivering robust, reliable, and cutting-edge technology services that drive success and growth.'}
            </p>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star star-color"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonialFive;
